import {
  UPDATE_VEHICLE_SUCCESS,
  UPDATE_VEHICLE_FAIL,
  VEHICLE_DETAILS_FAIL,
  VEHICLE_DETAILS_SUCCESS,
  ADD_VEHICLE_SUCCESS,
  ADD_VEHICLE_FAIL,
  VEHICLES_LIST_SUCCESS,
  VEHICLES_LIST_FAIL,
  VEHICLE_HISTORY_FAIL,
  VEHICLE_HISTORY_SUCCESS,
  DELETE_ATTACHMENT_SUCCESS,
  DELETE_ATTACHMENT_FAIL,
  ADD_VEHICLE_ATTACHMENT_SUCCESS,
  ADD_VEHICLE_ATTACHMENT_FAIL,
  GET_VEHICLE_LOGS_SUCCESS,
  GET_VEHICLE_LOGS_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  vehicleList: [],
  error: null,
  succRes: [],
  services: [],
  serviceDetail: [],
  vehicleDetail: [],
  delSucc: [],
  vehicleHistory: [],
  logs: [],
};

const Demo = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_VEHICLE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };
    case ADD_VEHICLE_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_VEHICLE_LOGS_SUCCESS:
      return {
        ...state,
        logs: action.payload,
      };
    case GET_VEHICLE_LOGS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        delSucc: action.payload,
      };
    case DELETE_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case VEHICLE_HISTORY_SUCCESS:
      return {
        ...state,
        vehicleHistory: action.payload,
      };
    case VEHICLE_HISTORY_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case VEHICLES_LIST_SUCCESS:
      return {
        ...state,
        vehicleList: action.payload,
      };
    case VEHICLES_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_VEHICLE_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };
    case ADD_VEHICLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case VEHICLE_DETAILS_SUCCESS:
      return {
        ...state,
        vehicleDetail: action.payload,
      };
    case VEHICLE_DETAILS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_VEHICLE_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };
    case UPDATE_VEHICLE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default Demo;
